import styles from "../../styles/shared/other-coins-signal/SearchCoins.module.css";
import { IoSearch } from "react-icons/io5";

function SearchCoins({
  searchValue,
  setSearchValue,
  selectedCoins,
  disabled,
}) {

  const handleChange = (e) => {
    setSearchValue(e.target.value);
  }

  return (
    <div
      className={`${styles.container} ${disabled ? styles.disabled : ""}`}
      style={{ width: `${selectedCoins?.length ? "15%" : "100%"}` }}
    >
      <span className={styles.searchIcon}>
        <IoSearch />
      </span>
      <input
        placeholder={searchValue || "Search coins..."}
        className={styles.searchInput}
        value={searchValue}
        onChange={handleChange}
      />
      {disabled && <div className={styles.disabledMask}></div>}
    </div>
  );
}

export default SearchCoins;
